module.exports = __webpack_public_path__ + "static/media/1.8b84d963.mp4";